module.exports = __webpack_public_path__ + "img/top-start-button.d148ebe1.png";